import styles from './subscribe-success.module.css';
import { withAdminAuth } from '../../components/GetAuth';
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "react-feather";
import PageHeader from '../../components/PageHeader';
import { useWebsite } from '../../../context/WebsiteContext';
import { useSiteBranding } from '../../../hooks/useSiteBranding';

function SubscribeSuccess() {

  const { websiteData } = useWebsite();
  useSiteBranding("Subscribe success", websiteData);

  return (<div className={`${styles.MainDiv}`}>
    <PageHeader title="Subscribe" />

    <div className={`${styles.successCard}`}>
      <div className={`${styles.checkIcon}`}><Check /></div>
      <p className={`${styles.successTitle}`}>You're all set!</p>
      <p className={`${styles.successText}`}>Your subscription is active and ready to go. You can start creating bookings right away.</p>
      <Link to={'/booking/add-booking'} className={`${styles.bookingBtn}`}>Make a new booking <ArrowRight /></Link>
    </div>

  </div>);
}

export default withAdminAuth(SubscribeSuccess);